import {
  Alert,
  AlertDescription,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import { TriangleAlertIcon } from 'lucide-react';

export type RemoveSsoCertificateModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** What identifies the certificate to the admin: its subject, or its fingerprint. */
  label: string;
  /** No other valid certificate would be left, which the API treats as a change of trust. */
  isLastValid: boolean;
  isRemoving?: boolean;
  onConfirm: () => void;
};

export const RemoveSsoCertificateModal = ({
  open,
  onOpenChange,
  label,
  isLastValid,
  isRemoving,
  onConfirm,
}: RemoveSsoCertificateModalProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Remove this certificate?</DialogTitle>
        <DialogDescription>
          Responses signed with {label} will no longer be accepted. This is the
          last step of a rotation, once your provider signs with the new
          certificate.
        </DialogDescription>
      </DialogHeader>

      {isLastValid && (
        <Alert variant="important">
          <TriangleAlertIcon />
          <AlertDescription>
            No valid certificate would be left: the connection returns to draft,
            single sign-on is switched off and the requirement lifted. Register
            the new certificate first, then remove this one.
          </AlertDescription>
        </Alert>
      )}

      <DialogFooter>
        <Button
          type="button"
          variant="outline"
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="destructive"
          onClick={onConfirm}
          isLoading={isRemoving}
        >
          Remove certificate
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
